module.exports = __webpack_public_path__ + "img/sign-success.17428c03.png";